import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'
import { EMAIL_REGEX, PHONE_REGEX } from "../utils/constants"
import { requiredPostalCode } from "./postalCodeSchema"

export const addCarwashSchema = Yup.object().shape({
    washname: Yup.string().required(CommonMessages.washname_required),
    address: Yup.string().required(CommonMessages.address_required),
    city: Yup.string().required(CommonMessages.city_required),
    country: Yup.string().required(CommonMessages.country_required),
    state: Yup.string().required(CommonMessages.state_required),
    zipcode: requiredPostalCode(),
    name: Yup.string().required(CommonMessages.name_required),
    emailid: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
    phonenumber: Yup.string()
        .matches(PHONE_REGEX, 'Phone number is not valid')
        .required(CommonMessages.phone_required),
})

export const editCarwashSchema = addCarwashSchema.concat(
    Yup.object().shape({
        country: Yup.string().required(CommonMessages.country_required),
    })
)